import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import '../Checklist/index.css';
import './index.css';
import { Modal } from 'react-bootstrap';
const FillSupplierModal = ({ showOptionModal, onCancel, onSubmit, columnInfo, selectedSupplierType }) => {

  const [selectedSupplierTypes, setSelectedSupplierType] = useState(undefined);
  const [pricingRows, setPricingRows] = useState([{
    days: null,
    price: null,
  }]);

  useEffect(() => {
    setSelectedSupplierType(selectedSupplierType)
  }, [])

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      width: '50%',
      transform: 'translate(-50%, -50%)',
      padding: '5px 10px 10px',
      maxHeight: '550px',
      minHeight: '200px',
    },
  };

  const customSelectStyles = {
    input: () => ({
      height: '24px',
    }),
  };

  const DaysOptions = [...Array(30)].map((a, b) => ({
    label: b + 1,
    value: b + 1,
  }));

  const onAddPricingClick = () => {
    setPricingRows([...pricingRows, ...{}])
  }

  const handleInputChange = (e, option) => {
    selectedSupplierType.attributes.forEach((attribute) => {
      if (attribute.name === option.name) {
        attribute.isChecked = e.target.checked;
      }
    });
    setSelectedSupplierType(selectedSupplierType)
  }

  const renderAttributeRow = (attribute, attrIndex) => {
    if (attribute.isChecked === false) return;
    if (
      attribute.type === 'SUPPLIER_TYPE' ||
      attribute.type === 'BASE_SUPPLIER_TYPE' ||
      attribute.type === 'INVENTORY_TYPE'
    ) {
      return;
    }
    return (
      <div className="createform__form__row" key={`row-${attrIndex}`}>
        <div className="createform__form__inline supplier-modal-input">
          <div className="form-control">
            <input type="text" value={attribute.name} disabled />
          </div>
          <div className="form-control">{renderInputField(attribute, attrIndex)}</div>
        </div>
      </div>
    );
  }

  const renderPricingRow = (row, index) => {
    const onDaysChange = (day) => {
      let pricingRow = [...pricingRows];
      pricingRow[index] = {
        ...pricingRows[index],
        days: day,
      };
      setPricingRows(pricingRows)
    };

    const onPriceChange = (event) => {
      let pricingRow = [...pricingRows];
      pricingRow[index] = {
        ...pricingRow[index],
        price: event.target.value,
      };
      setPricingRows(pricingRow)
    };

    const onCancel = () => {
      let pricingRow = [...pricingRows];
      pricingRow.splice(index, 1);
      setPricingRows(pricingRow)
    };

    return (
      <div className="createform__form__inline supplier-modal-input" key={index}>
        <div className="form-control">
          <Select
            options={DaysOptions}
            value={row.days}
            onChange={onDaysChange}
            classNamePrefix="form-select"
          />
        </div>
        <div className="form-control">
          <input type="number" placeholder="Price" value={row.price} onChange={onPriceChange} />
        </div>
        {''}
        {pricingRows.length > 1 ? (
          <button type="button" className="btn btn--link" onClick={onCancel}>
            X
          </button>
        ) : null}
      </div>
    );
  }

  const handleAttributeChange = (attribute, index) => {
    const selectedSupplierTypes = Object.assign({}, selectedSupplierType);
    selectedSupplierTypes.attributes.splice(index, 1, attribute);
    setSelectedSupplierType(selectedSupplierTypes)
  }

  const renderInputField = (attribute, attrIndex) => {
    const onValueChange = (event) => {
      const newAttribute = Object.assign({}, attribute);
      if (event.target.type === 'number') {
        newAttribute.value = parseFloat(event.target.value);
      } else {
        newAttribute.value = event.target.value;
      }
      handleAttributeChange(newAttribute, attrIndex);
    };
    const onDropDownAttributeValueChange = (newValue) => {
      const newAttribute = Object.assign({}, attribute);
      newAttribute.value = newValue.value;
      handleAttributeChange(newAttribute, attrIndex);
    };

    switch (attribute.type) {
      case 'FLOAT':
        return (
          <input
            type="number"
            placeholder="Attribute Value"
            value={attribute.value}
            onChange={onValueChange}
          />
        );
      case 'STRING':
        return (
          <input
            type="text"
            placeholder="Attribute Value"
            value={attribute.value}
            onChange={onValueChange}
          />
        );
      case 'EMAIL':
        return (
          <input
            type="email"
            placeholder="Attribute Value"
            value={attribute.value}
            onChange={onValueChange}
          />
        );
      case 'DROPDOWN':
        let attributeValueOptions = [];
        attribute.options.forEach((option) => {
          attributeValueOptions.push({ label: option, value: option });
        });
        return (
          <Select
            styles={customSelectStyles}
            options={attributeValueOptions}
            value={{ label: attribute.value, value: attribute.value }}
            onChange={onDropDownAttributeValueChange}
          />
        );
      default:
        return;
    }
  }

  let supplierTypeText;
  if (columnInfo.attribute.type === 'SUPPLIER_TYPE') {
    supplierTypeText = 'Supplier Type';
  } else if (columnInfo.attribute.type === 'BASE_SUPPLIER_TYPE') {
    supplierTypeText = 'Base Supplier Type';
  } else {
    supplierTypeText = 'Base Inventory';
  }


  return (
  <Modal show={showOptionModal} onHide={onCancel} className={'theme-modal'} style={customStyles} id={''} size={'md'}>
    <Modal.Header closeButton>
      <Modal.Title>
        <h3>Fill Attributes for{' '}{selectedSupplierType.type === 'SUPPLIER_TYPE' ? 'Supplier Type' : ' Base Supplier Type'}      </h3>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="createform__form">
        <div className="title">
          {supplierTypeText + ': ' + selectedSupplierType.label}
        </div>
      </div>
      <div className="createform__form">
        {selectedSupplierType
          ? selectedSupplierType.attributes.map(renderAttributeRow)
          : undefined}
      </div>
      <div className="createform__form">
        <div className="title">Add Pricing Details</div>
        {pricingRows.map(renderPricingRow)}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <div className="modal-footer">
        <button type="button" className="btn btn--danger" onClick={onAddPricingClick}>
          Add Pricing
        </button>{' '}
        <button
          type="button"
          className="btn btn--danger"
          onClick={() => onSubmit(selectedSupplierType, columnInfo, pricingRows.map((item) => ({ ...item, days: item.days.value })))}
        >
          Submit
        </button>{' '}
        <button type="button" className="btn btn--danger" onClick={onCancel}>
          Close
        </button>
      </div>
    </Modal.Footer>
  </Modal>)
}

export default FillSupplierModal;
